import React from "react";
import { Box, Paper, Stack, Typography, Button } from "@mui/material";

const StepCard = ({ step, index, openModal, navigateTo }) => {
    return (
        <Paper
        elevation={3}
        sx={{
            p: { xs: 2, md: 4 },
            textAlign: "center",
            borderRadius: 10,
            mx: "auto",
            maxWidth: 550,
            minHeight: 320,
        }}
        >
        <Stack direction={{ xs: "column", md: "row" }} spacing={3} alignItems="center" height="100%">
            <Box component="img" src={step.image} alt={step.title} sx={{ width: { xs: "110px", md: "200px" } }} />

            <Box textAlign="left" flex={1}>
            <Typography sx={{ display: "flex", alignItems: "flex-end", gap: 1, mb: 1 }}>
                <Box
                component="span"
                sx={{
                    fontSize: { xs: "1.8rem", md: "6rem" },
                    fontWeight: "bold",
                    color: "#f4c829",
                    lineHeight: 1,
                }}
                >
                {index + 1}.
                </Box>
                <Box
                component="span"
                sx={{
                    fontSize: { xs: "1.1rem", md: "1.8rem" },
                    fontWeight: "bold",
                    color: "#f4c829",
                }}
                >
                {step.title}
                </Box>
            </Typography>

            <Typography
                sx={{
                color: "#1B1464",
                fontSize: { xs: "0.95rem", md: "13px" },
                lineHeight: 1.2,
                maxWidth: 318,
                mt: 3,
                textAlign: "justify",
                }}
            >
                {step.content}
            </Typography>

            {step.buttonLabel && (
                <Box display="flex" justifyContent="center" sx={{ mt: 4 }}>
                <Button
                    variant="contained"
                    sx={{
                    backgroundColor: "#F4CC3B",
                    color: "#1B1464",
                    fontWeight: "bold",
                    borderRadius: 8,
                    textTransform: "none",
                    fontSize: { xs: 14, md: 16 },
                    px: { xs: 2, md: 4 },
                    py: { xs: 1, md: 1.5 },
                    "&:hover": { backgroundColor: "#f1b800" },
                    }}
                    onClick={() => (step.openModal ? openModal() : navigateTo(step.buttonLink))}
                >
                    {step.buttonLabel}
                </Button>
                </Box>
            )}
            </Box>
        </Stack>
        </Paper>
    );
};

export default StepCard;
